import * as z from "zod/v4";

export const zTag = z.object({
  id: z.number(),
  key: z.string().min(1).toLowerCase(),
  label: z.string().min(1),
  category: z.enum(["role", "competence"]),
});

export type Tag = z.infer<typeof zTag>;
